import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';
import { getUserListByMgid, MgUserResponse} from 'services/parametersService';


export type MgUserListSelectProps = {
  mgid?: number;
  value?:   MgUserResponse;
  onChange?: (userListByMgid?:MgUserResponse) => void;
  onSelected?: (userListByMgid: MgUserResponse) => void;
  disabled?: boolean;
  allowClear?:boolean;
  style?: any;
};

const MgUserListSelect = ({
  mgid,
  value,
  onChange = noop,
  onSelected,
  ...otherProps
}: MgUserListSelectProps) => {
  const { data: userListByMgid,isLoading} = useQuery<MgUserResponse[]>(
    ['getUserListByMgid', { mgid:mgid?mgid:Number(localStorage.getItem('mgid'))??0 }],
    () => {
      return getUserListByMgid({
        mgid:mgid?mgid:Number(localStorage.getItem('mgid'))??0,
      }).then((res) => res.list || []);
    },
    {
      enabled: !!localStorage.getItem('mgid'),
    }
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
   
    
     onChange(value);
    if (onSelected) {
    
      onSelected(userListByMgid?.find((item) => item.userid === value)!);
     
    }
  };
  return (
    <Select value={value} onChange={handleChange} {...otherProps} loading={isLoading}>
      {userListByMgid?.map((e) => (
        <Select.Option value={e.userid} key={e.mguserid}>
          {e.name + ' ' + e.surname}
        </Select.Option>
      ))}
    </Select>
    
  );
};

export default MgUserListSelect;
